import { defineStore } from 'pinia';
import { DiagnosisCodeData, DiagnosisService, ProcedureCodeData } from 'src/services/DiagnosisService';

export const useDiagnosisStore = () => {
  const diagnosisStore = defineStore('diagnosis', {
    state: () => ({
      isInitialized: undefined as boolean | undefined,
      diagnosisService: undefined as DiagnosisService | undefined,
      diagnosisData: undefined as DiagnosisCodeData[] | undefined,
      procedureData: undefined as ProcedureCodeData[] | undefined,

    }),
    actions: {
      async initialize() {
        if (!this.diagnosisService) {
          this.diagnosisService = new DiagnosisService();
        }
        this.diagnosisData = this.diagnosisService.getDiagnoses();
        this.procedureData = this.diagnosisService.getProcedureCodes();
        this.isInitialized = true;
      },
    },
  });
  const store = diagnosisStore();
  if (store.isInitialized === undefined) {
    store.initialize();
  }
  return store;
};
